var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16948_3420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.348 10.0899L6.3475 5.5625L10.6705 7.834L6.348 10.0899ZM15.84 4.77797C15.84 4.77797 15.6835 3.66766 15.204 3.17871C14.5955 2.53669 13.9135 2.53366 13.601 2.4964C11.362 2.33325 8.0035 2.33325 8.0035 2.33325H7.9965C7.9965 2.33325 4.638 2.33325 2.399 2.4964C2.086 2.53366 1.4045 2.53669 0.795502 3.17871C0.316002 3.66766 0.159999 4.77797 0.159999 4.77797C0.159999 4.77797 0 6.08216 0 7.38584V8.60846C0 9.91264 0.159999 11.2163 0.159999 11.2163C0.159999 11.2163 0.316002 12.3266 0.795502 12.8156C1.4045 13.4576 2.204 13.4375 2.56 13.5044C3.84 13.6283 8 13.6666 8 13.6666C8 13.6666 11.362 13.6616 13.601 13.4984C13.9135 13.4606 14.5955 13.4576 15.204 12.8156C15.6835 12.3266 15.84 11.2163 15.84 11.2163C15.84 11.2163 16 9.91264 16 8.60846V7.38584C16 6.08216 15.84 4.77797 15.84 4.77797Z",
    fill: "#CE1312"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16948_3420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4273e2f9aa96c9e67971f7cb3f88c7eb.svg";
export { ForwardRef as ReactComponent };